import { useAppDispatch, useAppSelector } from 'app/store';
import { getPinnedSongs, isFetchingSongs } from 'app/store/SongList/selectors';
import { useEffect } from 'react';
import { getCurrentProfileGuid } from 'app/store/Profile/selectors';
import { fetchPinnedSongsEffect } from 'app/store/SongList/effects';
import { PinnedSongsSectionComponent } from './PinnedSongsSectionComponent';

export const PinnedSongsSection = () => {
  const dispatch = useAppDispatch();
  const songs = useAppSelector(getPinnedSongs);
  const isFetching = useAppSelector(isFetchingSongs);
  const profileGuid = useAppSelector(getCurrentProfileGuid);

  useEffect(() => {
    dispatch(fetchPinnedSongsEffect());
  }, [dispatch]);

  return (
    <PinnedSongsSectionComponent
      profileGuid={profileGuid}
      songs={songs}
      isFetching={isFetching}
      dispatch={dispatch}
    />
  );
};
